<div class="dropdown" #dropdown *ngIf="canEdit; else list">
    <button 
        (click)="searchInput.focus()"
        class="add-site faded trigger">
        <label>Tags</label>
        <span class="terms">
            <span class="term" *ngFor="let term of terms; let i = index; trackBy: utils.trackByIndex">
                <span class="name" [innerHtml]="term.name"></span>
                <mat-icon (click)="removeTerm($event, i)">close</mat-icon>
            </span>
            <span class="term" *ngFor="let term of tempTerms; let i = index; trackBy: utils.trackByIndex">
                <span class="name" [innerHtml]="term.name"></span>
                <mat-icon (click)="removeTemp($event, i)">close</mat-icon>
            </span>
        </span>
        <input 
            #searchInput
            type="search" 
            placeholder="{{placeholder}}" 
            [(ngModel)]="searchText" 
            (keydown.enter)="addOrCreateTerm(searchText)"
            (input)="search(searchText)"
            (blur)="maybeReset($event)"
            (focus)="search(searchText)"
            (keydown.arrowdown)="selectDown($event)"
            (keydown.arrowup)="selectUp($event)"
            (keydown.backspace)="removeTerm($event, terms.length - 1)"
            name="inputSearchTags"
            autocomplete="inputSearchTags"
            id="inputSearchTags{{inputSearchTags}}"
        />
    </button>
    <div class="options-panel" id="site-select" [ngClass]="{'open': options.length > 0}">
        <ul class="options">
            <li *ngFor="let option of options; trackBy: utils.trackByIndex" (click)="addTerm(option)" class="option" [ngClass]="{'option-selected': option.selected}">
                <span [innerHtml]="option.name"></span>
            </li>
        </ul>
    </div>
</div>
<ng-template #list>
    <label>Tags</label>
    <span *ngIf="terms.length > 0; else placeholderContainer" class="terms placeholder faded">
        <span class="term" *ngFor="let term of terms; trackBy: utils.trackByIndex" [innerHtml]="term.name"></span>
    </span>
    <ng-template #placeholderContainer>
        <span class="placeholder faded">{{placeholder}}</span>
    </ng-template>
</ng-template>